// extracted by mini-css-extract-plugin
export default {"radioGroupPage":"RadioGroupPage_radioGroupPage__XSkla","radioGroupPageStandFirst":"RadioGroupPage_radioGroupPageStandFirst__bEXmV"};